import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  base_url, Apitoken, Authtoken } from "../Global";
// import $ from "jquery";
import PropTypes from 'prop-types';
import {MaterialReactTable} from "material-react-table";

import { loader_image } from "../_components/Imagepath";

const CustomerOrders = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);

 
  const options =([
    //{ value: "1", label: "PENDING" },
    { value: "2", label: "IN-PRODUCTION" },
    { value: "3", label: "CONFIRMED" },
    { value: "4", label: "SHIPPED" },
    //{ value: "5", label: "CANCELLED" },
    { value: "6", label: "PRODUCED" },
    { value: "7", label: "DELIVERED" },
  ]);

  //const [selectedOptions, setSelectedOptions] = useState([]);
  // const [filterdownloadbtn, setFilterdownloadbtn] = useState(false);


  
  const handleSelectChange = (selectedOptions) => {
    setFormData({ ...formData, order_stats: selectedOptions ? selectedOptions.map(option => option.value) : [] });
  };
  let customer_id = localStorage.getItem("customer_id");
  let season_id = localStorage.getItem("season_id");

  const [formData, setFormData] = useState({
    season_id: season_id,
    customer: customer_id,
    user_type: 'portal_user',
    order_stats: [],
    start_date: "",
    end_date: "",
  });
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  console.log("not formData");
  console.log(formData);
  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("formData");
    console.log(formData);
    axios
      .post("/customerportal/orders/listing", formData, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.orders);
     
          //setFilterdownloadbtn(true);
          //$("#filtered-excel-button").show();

       
        } else {
          //setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
  

    axios
      .post("/customerportal/orders/listing", formData, {
        headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.orders);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  const PONumberCell = ({ row }) => {
    return (
      <a href={`/customerportal/orders-view/${row.original.id}`} className="">
        {row.original.po_number}
      </a>
    );
  };
  
  // ✅ Define PropTypes
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        po_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const OrderStatusCell = ({ row }) => {
    const status = row.original.status;
  
    return (
      <button
        type="button"
        className="btn btn-block me-1"
        id={`status-confirmed-${row.original.id}`}
        style={{
          backgroundColor: status?.bg_color || '#ccc',
          color: status?.color || '#000',
        }}
      >
        {status?.title || ''}
      </button>
    );
  };
  
  // ✅ Define PropTypes for validation
  OrderStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        status: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
  };
  const columns = [

    {
      header: 'PO Number',
      accessorFn: (row) => `${row.po_number}`,
      Cell: PONumberCell, // ✅ Use the separate component
    },
   
    {
      accessorKey: 'eta_week', //normal accessorKey
      header: 'ETA Week',
    },

    {
      header: "Shipping method",
      accessorFn: (row) => `${row.ship_method ? row.ship_method.title : ""} `,
    },
    {
      header: "Shipping Address",
      accessorFn: (row) => `${row.ship_address ? row.ship_address.name : ""} `,
    },
    {
      header: "Order Status",
      accessorFn: (row) => `${row.status ? row.status.title : ""} `,
      Cell: OrderStatusCell, // ✅ use external component
    }
   
  ];

  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
      )
      .join("&");
  }
  const downloadExcel = (e) => {
    console.log(formData);
    let order_statss = formData.order_stats;
    let all_status = [];
    order_statss.map((brk, index) => {
      console.log(index);
      all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(e);


    const queryString = objectToQueryString(formData);
   
        window.open(
          `${base_url}/customerportal/orders/listing-excel?${queryString}`,
          "_blank"
        );

  };


  return (
    <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Orders</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/customerportal/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Orders</li>
                </ul>
              </div>
              <div className="col-auto">
                
                &nbsp;&nbsp;
                <button
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>{" "}
                  <i className="fa fa-download"></i>
                  <img
                    id="loader-image2"
                    className="loader-image2 loader-hide2"
                    src={loader_image}
                  />
                </button>
              </div>
            </div>
          </div>
          <div id="filter_inputs" className="card filter-card1">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  

                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Order Status:</label>

                      <Select
                        
                        isMulti
                        options={options}
                        name="order_stats"
                        value={options.filter(option => formData.order_stats?.includes(option.value))} 
                        onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                      />
                    </div>
                  </div>
                 

                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a
                        href="/customerportal/orders"
                        className="btn btn-primary me-1"
                      >
                        <i className="fa fa-times"></i>
                      </a>{" "}
                   
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <section className="comp-section order-listing-page">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <MaterialReactTable
                        columns={columns}
                        data={data}
                        enableColumnOrdering
                        enablePinning
                     
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CustomerOrders;
